import { useNavigate } from 'react-router';
import { Button } from '@tempmee/react';
import { OutlineArrowLeftIcon } from '@tempmee/react-icons';

interface DSBackButtonProps {
  onClick?: () => void;
  url?: string;
}

export const DSBackButton = ({ onClick, url }: DSBackButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) return onClick();
    if (url) return navigate(url);
    navigate(-1);
  };

  return (
    <Button
      variant="ghost"
      size="inline"
      type="button"
      onClick={handleClick}
      LeadingIcon={<OutlineArrowLeftIcon />}
    >
      Back
    </Button>
  );
};
